import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';

import { ColorTheme } from '@models/color-theme';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ColorsThemeService {

  private platformId = inject(PLATFORM_ID);
  private document = inject(DOCUMENT);
  public test(colorTheme: ColorTheme) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.document.documentElement.style.setProperty('--color-accent', colorTheme.colorAccent);
    this.document.documentElement.style.setProperty('--color-primary', colorTheme.colorPrimary);
    this.document.documentElement.style.setProperty('--color-primary-variant', colorTheme.colorPrimaryVariant);
    this.document.documentElement.style.setProperty('--color-tertiary', colorTheme.colorTertiary);
    this.document.documentElement.style.setProperty('--color-neutral-white', colorTheme.colorNeutralWhite);
  }

  public revert() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.document.documentElement.style.removeProperty('--color-accent');
    this.document.documentElement.style.removeProperty('--color-primary');
    this.document.documentElement.style.removeProperty('--color-primary-variant');
    this.document.documentElement.style.removeProperty('--color-tertiary');
    this.document.documentElement.style.removeProperty('--color-neutral-white');
  }

}
